<!--
 * @Author: guojia 66291979@qq.com
 * @Date: 2024-05-10 12:27:02
 * @LastEditors: guojia 66291979@qq.com
 * @LastEditTime: 2024-09-04 20:08:12
 * @FilePath: /lobby/src/components/active/ActiveMarquee.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <div class="award_scroll">
    <img :src="`${resBaseUrl}trumpet.png`" />
    <div class="marquee">
      <div id="myElement" class="continer">
        <a class="notice" v-for="(item, index) in items" :key="index" v-html="item" />
      </div>
    </div>
    <!-- <van-swipe :autoplay="0" :show-indicators="false" class="marquee" :touchable="false">
      <van-swipe-item v-for="(item, index) in items" :key="index" style="width: auto">
        {{ item }}
      </van-swipe-item>
    </van-swipe> -->
  </div>
</template>
<script>
import { config } from '@/common/config.js'
import { useLobbyStore } from '@/stores/lobby'
import { useUserStore } from '@/stores/user'
import { formatMoney, formatDate } from '@/utils/helper'
import { mapActions, mapState } from 'pinia'
import { useEnvelopeStore } from '@/stores/envelope'
export default {
  name: 'DhMarquee',
  data() {
    return {
      resBaseUrl: config.resBaseUrl,
      speed: 10,
      items: [],
      distance: 0
    }
  },
  computed: {
    ...mapState(useUserStore, ['balance'])
  },
  mounted() {
    this.distance = 0
    this.claimed().then((res) => {
      console.log('-=-=-=:', res)
      this.items = []
      for (let i = 0; i < res.records.length; i++) {
        const record = res.records[i]
        if (this.$t) {
          this.items.push(
            this.$t('active.tips', {
              nickname: '<span style="color:#7ECEF4;">' + record.nickname + '</span>',
              value: '<span style="color:#FFF799;">' + this.formatMoney(record.reward) + '</span>',
              currency: '<span style="color:#FFF799;">' + record.currency + '</span>' //'BIRR', //this.unitConversion(this.balance.currency),
              // game: formatDate(record.time)
            })
          )
        }
      }
      this.startMarquee()
    })
    // this.notice().then((res) => {
    //   console.log('-=-=-=:', res)
    //   this.items = []
    //   for (let i = 0; i < res.records.length; i++) {
    //     const record = res.records[i]
    //     if (this.$t) {
    //       this.items.push(
    //         this.$t('notice.tips', {
    //           phone: record.phone_number,
    //           amount: this.formatMoney(record.amount),
    //           unitconversion: 'BIRR', //this.unitConversion(this.balance.currency),
    //           game: record.game_name
    //         })
    //       )
    //     }
    //   }
    //   this.startMarquee()
    // })
  },
  methods: {
    formatMoney,
    formatDate,
    ...mapActions(useLobbyStore, { notice: 'notice' }),
    ...mapActions(useEnvelopeStore, { claimed: 'claimed' }),
    startMarquee() {
      const element = document.getElementById('myElement')
      if (element) {
        const { width } = element.getBoundingClientRect()
        if (this.distance < Math.floor(width)) {
          this.distance += 0.5
          if (!element) {
            return
          }
          element.style.transform = `translateX(-${this.distance}px)`
        } else {
          this.distance = 0
          element.style.transform = `translateX(0}px)`
        }
      }
      window.requestAnimationFrame(this.startMarquee)
    },
    unitConversion(code) {
      // if (code == 'ETB') {
      //   return 'BIRR'
      // }
      return code
    }
  }
}
</script>
<style lang="scss" scoped>
.award_scroll {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  line-height: 0.4rem;
  max-width: calc(100% - var(--page-padding));
  width: calc(100% - var(--page-padding));
  overflow: hidden;
  scrollbar-width: none;
  /* firefox */
  -ms-overflow-style: none;
  /* IE 10+ */
  // overflow-x: hidden;
  // overflow-y: auto;
  padding-left: var(--page-padding);
  padding-right: var(--page-padding);
  margin-top: -0.7rem;

  img {
    width: 0.33rem;
    height: 0.33rem;
  }

  .marquee::-webkit-scrollbar {
    height: 0;
    /* 隐藏滚动条，但保持滚动功能 */
    display: none;
  }

  .marquee {
    width: 95%;
    height: 1rem; // 根据实际情况设置高度
    margin-left: 0.1rem;
    overflow-y: hidden;
    overflow-x: hidden;
    -ms-overflow-style: none;

    .continer {
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-direction: row;
      width: max-content;
      height: 1rem;

      .notice {
        width: max-content;
        height: auto;
        font-size: 0.24rem;
        margin-right: 0.3rem;
      }
    }

    // @keyframes noticeAnimation {
    //   0% {
    //     transform: translateX(0%); // 开始时不偏移
    //   }
    //   100% {
    //     transform: translateX(-100%); // 结束时向左偏移100%，即完整滚动一次
    //   }
    // }
    // .van-swipe-item {
    //   width: auto;
    //   height: 1rem;
    //   line-height: 1rem; // 根据实际情况设置行高
    //   // animation: marquee 10s linear infinite; // 设置匀速滚动动画，10s表示滚动一次，linear表示匀速
    //   color: #fff;
    //   text-align: left;
    //   display: inline-block;
    //   margin: 0 0.1rem;
    //   font-size: 0.25rem;
    // }
  }
}
</style>
